var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInvitationsYetIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 138,
    viewBox: "0 0 162 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.012 46.889c-10.374-.36-20.253-3.7-29.688-7.351-9.435-3.651-18.779-7.7-28.9-9.636-6.512-1.245-13.96-1.421-19.207 2.06-5.05 3.356-6.682 9.132-7.559 14.5-.66 4.036-1.048 8.285.76 12.063 1.257 2.624 3.485 4.829 5.026 7.343 5.365 8.744 1.572 19.527-4.24 28.065-2.725 4.006-5.89 7.83-7.995 12.09-2.105 4.26-3.077 9.148-1.236 13.5 1.824 4.314 6.172 7.549 10.883 9.826 9.567 4.626 20.837 5.949 31.834 6.7 24.336 1.66 48.8.941 73.2.222 9.03-.267 18.1-.537 26.982-1.929 4.933-.773 10.026-2 13.608-4.962a11.338 11.338 0 0 0 2.625-14.842c-5.11-7.908-19.234-9.872-22.81-18.36-1.965-4.671.053-9.874 2.911-14.208 6.129-9.294 16.4-17.448 16.942-28.071.372-7.3-4.566-14.6-12.2-18.057-8-3.618-19.1-3.164-25 2.827-6.092 6.164-16.777 8.54-25.936 8.22z",
    fill: "#FF9B01"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xa2sqpq1ta)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 65.172c-2.56 0-5.138-.64-7.325-2.363L41 39.203V72.5c0 4.14 3.36 7.5 7.5 7.5h65c4.141 0 7.5-3.36 7.5-7.36V39.204l-32.672 23.61A12.629 12.629 0 0 1 81 65.171zm37.125-39.703a238.838 238.838 0 0 0-4.625-3.578v-6.894c0-4.14-3.359-7.5-7.5-7.5H93.89c-.488-.351-.917-.664-1.425-1.015C89.844 4.552 84.64-.058 81 0c-3.625-.058-8.844 4.552-11.469 6.484-.508.352-.937.664-1.425 1.016H56c-4.14 0-7.5 3.36-7.5 7.5v6.894a282.34 282.34 0 0 0-4.628 3.575C42.055 26.875 41 29.062 41 31.375v1.66l15 10.839V15h50v28.86l15-10.84v-1.645c0-2.313-1.047-4.5-2.875-5.906zM68.5 39.859h25c1.38 0 2.5-1.119 2.5-2.359a2.5 2.5 0 0 0-2.5-2.5h-25a2.5 2.5 0 0 0-2.5 2.5c0 1.375 1.125 2.36 2.5 2.36zm0-10h25a2.5 2.5 0 0 0 2.5-2.5C96 25.98 94.88 25 93.5 25h-25c-1.38 0-2.5 1.12-2.5 2.36 0 1.515 1.125 2.5 2.5 2.5z",
    fill: "#FF9B01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xa2sqpq1ta"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(41)",
    d: "M0 0h80v80H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInvitationsYetIcon);
export default __webpack_public_path__ + "static/media/no-invitations-yet-icon.e8e2afdc4e47275ac24a598f60cf5ed3.svg";
export { ForwardRef as ReactComponent };